export default class AlertMessage {
    constructor() {
        this.snack = this.resetAlert();
    }
    resetAlert() {
        this.snack = { show: false, text: '', time: 4000, color: "grey darken-4", btnFColor: "red", multiple:false };
        return this.snack;
    }
   
    snackSuccess() {
        this.snack.color = "green darken-3";
        this.snack.btnFColor = "white";
    }
    snackDanger() {
        this.snack.color = "red darken-4";
        this.snack.btnFColor = "white";
    }
    snackAlert() {
        this.snack.color = "amber accent-4";
        this.snack.btnFColor = "black";
    }
    snackDefault() {
        this.snack.color = "grey darken-4";
        this.snack.btnFColor = "red";
    }

}





// WEBPACK FOOTER //
// ./src/domain/alertMessage/AlertMessage.js